import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { base_url } from "../utils/axiosConfig";
import axios from 'axios';
import CustomInput from '../components/CustomInput';

const ForgetPassword = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await axios.post(`${base_url}user/forgot-password-token`, { email });
      setMessage('Password reset link sent to your email.');
      setError('');
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to send reset link. Please try again.');
      setMessage('');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-wrapper py-5 home-wrapper-2">
      <div className="container-xxl d-flex justify-content-center">
        <div className="card p-4 p-md-5 shadow rounded-3" style={{ maxWidth: '400px', width: '100%' }}>
          <h3 className="text-center mb-3 fw-semibold">Reset Your Password</h3>
          <p className="text-center text-muted mb-4 small">
            Enter your email and we will send you instructions to reset your password.
          </p>

          {message && <div className="alert alert-success">{message}</div>}
          {error && <div className="alert alert-danger">{error}</div>}

          <form onSubmit={handleSubmit} className="d-flex flex-column gap-3">
            <CustomInput
              type="email"
              name="email"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />

            <button
              type="submit"
              className="btn btn-primary w-100 mt-2"
              disabled={loading}
            >
              {loading ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                  Sending...
                </>
              ) : (
                'Submit'
              )}
            </button>

            <Link to="/login" className="btn btn-outline-secondary w-100">
              Cancel
            </Link>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ForgetPassword;